import * as types from '../constants';

const initialState = {
  loading: true,
  graphLoading: true,
  statsLoading: true,
  subs: {},
  graph: [],
  dailyStats: {},
  saff: [],
  stats: [],
  hourlyStats: {},
  subStats: {},
  referrerStats: {},
  geoStats: {},
  xmlFeeds: {},
  clickStats: {},
};

const reducer = (state = initialState, action) => {
  switch (action.type) {
    case types.FETCH_DASH_GRAPH_START:
      return {
        ...state,
        graphLoading: true,
      };

    case types.FETCH_DASH_GRAPH_SUCCESS:
      return {
        ...state,
        graphLoading: false,
        graph: action.payload,
      };

    case types.FETCH_DASH_GRAPH_FAILURE:
      return {
        ...state,
        err: action.err,
        graphLoading: true,
      };

    case types.FETCH_DASH_TOP_START:
      return {
        ...state,
        loading: true,
        subs: {}
      };

    case types.FETCH_DASH_TOP_SUCCESS:
      return {
        ...state,
        subs: action.payload,
        loading: false
      };

    case types.FETCH_DASH_TOP_FAILURE:
      return {
        ...state,
        subs: {},
        loading: true
      };

    case types.FETCH_DAILY_STATS_START:
      return {
        ...state,
        loading: true,
      };

    case types.FETCH_DAILY_STATS_SUCCESS:
      return {
        ...state,
        dailyStats: action.payload,
        loading: false,
      };

    case types.FETCH_DAILY_STATS_FAILURE:
      return {
        ...state,
        dailyStats: [],
        err: action.err,
        loading: false,
      };

    case types.FETCH_SAFF_LIST_START:
      return {
        ...state,
        err: false
      };

    case types.FETCH_SAFF_LIST_SUCCESS:
      return {
        ...state,
        saff: action.payload
      };

    case types.FETCH_SAFF_LIST_FAILURE:
      return {
        ...state,
        saff: [],
        err: action.err
      };

    case types.FETCH_DASH_STATS_START:
      return {
        ...state,
        statsLoading: true,
      };

    case types.FETCH_DASH_STATS_SUCCESS:
      return {
        ...state,
        statsLoading: false,
        stats: action.payload,
      };

    case types.FETCH_DASH_STATS_FAILURE:
      return {
        ...state,
        statsLoading: true,
        stats: []
      };

    case types.FETCH_HOURLY_STATS_START:
      return {
        ...state,
        hourlyStats: {},
        loading: true,
      };

    case types.FETCH_HOURLY_STATS_SUCCESS:
      return {
        ...state,
        hourlyStats: action.payload,
        loading: false,
      };

    case types.FETCH_HOURLY_STATS_FAILURE:
      return {
        ...state,
        err: action.err,
        loading: true,
      };

    case types.FETCH_SUB_STATS_START:
      return {
        ...state,
        subStats: {},
        loading: true,
      };

    case types.FETCH_SUB_STATS_SUCCESS:
      return {
        ...state,
        subStats: action.payload,
        loading: false,
      };

    case types.FETCH_SUB_STATS_FAILURE:
      return {
        ...state,
        err: action.err,
        loading: true,
      };

    case types.FETCH_REFERRER_STATS_START:
      return {
        ...state,
        referrerStats: {},
        loading: true,
      };

    case types.FETCH_REFERRER_STATS_SUCCESS:
      return {
        ...state,
        referrerStats: action.payload,
        loading: false,
      };

    case types.FETCH_REFERRER_STATS_FAILURE:
      return {
        ...state,
        err: action.err,
        loading: true,
      };

    case types.FETCH_GEO_STATS_START:
      return {
        ...state,
        loading: true,
        geoStats: {},
      };

    case types.FETCH_GEO_STATS_SUCCESS:
      return {
        ...state,
        loading: false,
        geoStats: action.payload,
      };

    case types.FETCH_GEO_STATS_FAILURE:
      return {
        ...state,
        loading: true,
        err: action.err,
      };

    case types.FETCH_CLICK_STATS_START:
      return {
        ...state,
        loading: true,
        clickStats: {},
      };

    case types.FETCH_CLICK_STATS_SUCCESS:
      return {
        ...state,
        loading: false,
        clickStats: action.payload,
      };

    case types.FETCH_CLICK_STATS_FAILURE:
      return {
        ...state,
        loading: false,
        err: action.err,
      };

    default:
      return state;
  }
};

export default reducer;
